import React from 'react';
import { strings } from '../../resources/strings';
import { ProfileType } from '../../enums/ProfileType';
import { useOrderUtils } from '../../hooks/useOrderUtils';
import ServicesContext from '../../contexts/ServicesContext';
import { DropdownButton, DropdownButtonColor, DropdownButtonDirection } from '../../common-components/DropdownButton/DropdownButton';

interface IOrderStateChangeButtonsProps {
  orderId?: number;
  isPhysicalStore?: boolean;
  currentStateId?: number;
  changed?: (newStateId: number) => void;
  userProfile?: ProfileType;
  orderTags?: string;
}

export const OrderStateChangeButtons: React.FC<IOrderStateChangeButtonsProps> = ({
  orderId,
  isPhysicalStore,
  currentStateId,
  changed,
  userProfile,
  orderTags
}) => {

  const {
    statesService,
    toastService
  } = React.useContext(ServicesContext);

  const {
    changeState,
    stopChangeIfOrderTagsIncludesExternalChange
  } = useOrderUtils();

  const getNextDropdownItems = (currentStateId?: number) =>
    statesService.translateListByUserProfile(
      statesService.filterByUserProfile(
        statesService.getNext(currentStateId), userProfile), userProfile).map(state => {
          const item = {
            key: state?.id,
            text: state?.name
          };
          return item;
        });

  const getPreviousDropdownItems = (currentStateId?: number) =>
    statesService.translateListByUserProfile(
      statesService.filterByUserProfile(
        statesService.getPrevious(currentStateId), userProfile), userProfile).map(state => {
          const item = {
            key: state?.id,
            text: state?.name
          };
          return item;
        });

  return (
    <>
      <DropdownButton
        items={getPreviousDropdownItems(currentStateId)}
        defaultStyle={true}
        small={true}
        direction={DropdownButtonDirection.DropToLeft}
        buttonColor={DropdownButtonColor.Success}
        text={' '}
        clickItem={(key) => handleChangeState(key)}
      />
      <DropdownButton
        items={getNextDropdownItems(currentStateId)}
        defaultStyle={true}
        small={true}
        direction={DropdownButtonDirection.DropToRight}
        buttonColor={DropdownButtonColor.Success}
        text={' '}
        clickItem={(key) => handleChangeState(key)}
        marginLeft={'3px'}
      />
    </>
  );

  function handleChangeState(newStateId: any) {
    if (!orderId) {
      toastService.warning(strings.MessageToPrintingSelectedOrdersEmpty);
      return;
    }

    if (stopChangeIfOrderTagsIncludesExternalChange(orderTags)) {
      return;
    }

    changeState(orderId, newStateId).then(() => changed ? changed(newStateId) : null);
  }
}